import './Layout.scss'
import {Header} from './header/Header'
import {useMediaQueries} from '../hooks/mediaQuery/useMediaQueries'
import {Outlet} from 'react-router-dom'
import {Footer} from './footer/Footer'
import config from '../config'
import {useContext} from 'react'
import {UserContext} from '../context/UserContext'
import {Avatar} from '../components/avatar/Avatar'
import {Dropdown} from '../components/dropdown/Dropdown'
import {logout} from '../api/authenticate'
import {useNavigate} from 'react-router'
import {handleUserLogout} from '../helpers/removeCurrUser'
import logo from '../assets/logo.svg'

export const Layout = () => {
    const { minTablet } = useMediaQueries();
    const {user} = useContext(UserContext);
    return (
        <>
            <Header>
                <Header.PrimaryNavigation>
                    <Header.Link hashLink={config.root + '/#home'}>
                        <img height={32} width={32} src={logo} alt={'Feedback Logo'}/>
                        UXForm
                    </Header.Link>
                    <Header.Link hashLink={config.root + '/#about'}>About</Header.Link>
                    <Header.Link hashLink={config.root + '/#pricing'}>Pricing</Header.Link>
                    <Header.Link hashLink={config.root + '/#faq'}>FAQ</Header.Link>
                    <Header.Link link={config.root + '/docs'}>Docs</Header.Link>
                </Header.PrimaryNavigation>
                <Header.SecondaryNavigation displaySize={minTablet ? 'desktop' : 'mobile'}>
                    {minTablet ? <DesktopLinks user={user} /> : <MobileMenuLink user={user} />}
                </Header.SecondaryNavigation>
            </Header>
            <main id={'home'}>
                <Outlet />
            </main>
            <Footer/>
        </>
    )
}

const DesktopLinks = ({user}) => {
    const navigate = useNavigate()

    const handleLogout = () => {
        logout()
            .then((data) => {
                if (data?.error) return
                navigate(config.root)
                handleUserLogout()
            })
    }

    return (
        <>
            {user ?
                <>
                    <Header.Link link={config.root + '/forms'}>Forms</Header.Link>
                    <Header.Link link={config.root + '/settings'} ariaLabel={"Settings"}>
                        <span aria-hidden="true" className="material-symbols-outlined">settings</span>
                    </Header.Link>
                    <li>
                        <Dropdown>
                            <Dropdown.Button><button aria-label={'Avatar Dropdown Menu'}><Avatar name={user?.name}/></button></Dropdown.Button>
                            <Dropdown.List>
                                <Dropdown.ListItem>
                                    <span><b>Logged in as</b>{user?.email}</span>
                                </Dropdown.ListItem>
                                <Dropdown.ListItem>
                                    <button onClick={handleLogout}>
                                        <span aria-hidden="true" className="material-symbols-outlined">logout</span>
                                        Logout
                                    </button>
                                </Dropdown.ListItem>
                            </Dropdown.List>
                        </Dropdown>
                    </li>
                </>
                :
                <>
                    <Header.Link link={config.root + '/login'}>Login</Header.Link>
                    <Header.Link link={config.root + '/signup'}>Sign up</Header.Link>
                </>
            }
        </>
    )
}

const MobileMenuLink = ({user}) => {
    return (
        <>
            <Header.Link link={config.root + '/docs'}>Docs</Header.Link>
            {user ?
                <>
                    <Header.Link link={config.root + '/forms'}>Forms</Header.Link>
                    <Header.Link link={config.root + '/settings'}>Settings</Header.Link>

                </>
                :
                <>
                    <Header.Link link={config.root + '/login'}>Login</Header.Link>
                    <Header.Link link={config.root + '/signup'}>Sign up</Header.Link>
                </>
            }
        </>
    )
}